module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-json-tree/~/babel-runtime/core-js/object/create.js
// module id = 1486
// module chunks = 0